import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ClientLayout } from '../../../features/B4/ClientLayout';

/**
 * Client page layout: crumbs, title, status pills, header actions, banners and the tab bar
 * (mockups/assets/screens/client.js). Child tabs render in <Outlet />.
 * `?site=<siteId>` selects the site on the tabs that have a site selector (multi-site clients); child routes inherit it.
 */
export const Route = createFileRoute('/_app/client/$clientId')({
  validateSearch: z.object({ site: z.string().max(64).optional().catch(undefined) }),
  component: ClientPage,
});

function ClientPage() {
  const { clientId } = Route.useParams();
  const { site } = Route.useSearch();
  return <ClientLayout clientId={clientId} site={site} />;
}
